import {
  getAuthenticatedAxios,
  withErrorHandler,
} from './AuthenticatedAxiosProvider';
import { buildRequestUrl } from '../Config';

export const PostUserDetails = async (profile) => {
  const { data } = await withErrorHandler(() =>
    getAuthenticatedAxios().post(
      buildRequestUrl('/api/users/user/post'),
      profile,
    ),
  );

  return data;
};
